export const persistWhitelist = [
  "User",
  "Roster",
  "Chat",
  "LoginUrl",
  "AuthMethod",
];
